'use client';

import classNames from 'classnames';

import styles from 'molecules/ContactSideBar/contactsidebar.module.scss';
import Link from 'molecules/Link';

import { isNonEmptyArray } from 'utils/functions';

import type { ContactSidebarProps } from 'molecules/ContactSideBar/config';
import type { FC } from 'react';

const ContactSidebar: FC<ContactSidebarProps & { className?: string }> = ({
  headingText,
  sidebarItems,
  footerHeader,
  footerText,
  className,
}) => (
  <section className={classNames(styles.wrapper, className)}>
    <div className={styles.inner}>
      <div className={styles.left_inner}>
        {headingText && (
          <div className={styles.headingText}>
            <p>{headingText}</p>
          </div>
        )}
        <div className={styles.sidebar}>
          {isNonEmptyArray(sidebarItems) &&
            sidebarItems.map(({ link, text }, index) => (
              <div className={styles.sidebarItemLink} key={`item-${index}`}>
                <Link href={link || '/'}>{text}</Link>
              </div>
            ))}
        </div>
      </div>
      <div className={styles.footerHeading}>
        {footerHeader && <p>{footerHeader}</p>}
        {footerText && (
          <div className={styles.footerText}>
            <p>{footerText}</p>
          </div>
        )}
      </div>
    </div>
  </section>
);

export default ContactSidebar;
